<template>
    <div id="myLotsSelect">
        <el-select :placeholder="placeholder" v-model="value" @clear="clear(value)" :multiple="multiple"
        :multiple-limit="multipleLimit" :collapse-tags="collapseTags"
        :filterable="filterable" @change="sendSelectValue" :disabled="disabled" clearable>
            <el-option
                v-for="(item,index) in options"
                :key="index"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
            ></el-option>
        </el-select>
    </div>
</template>

<script>
import { dictWithUrl } from '@/components/lots/api';
export default {
    data() {
        return {
            options: [],
            value: ''
        };
    },
    props: {
        url: String,
        optionArr: Array,
        optionNum: String,
        placeholder: String,
        prop: String,
        multiple: Boolean,
        mValue: [String, Number, Array],
        disabled: {
            type: Boolean,
            default: false
        },
        filterable: Boolean,
        collapseTags: {
            type: Boolean,
            default: false
        },
        multipleLimit: {
            type: Number,
            default: 0
        },
        disabledOptions: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    watch: {
        optionArr(val) {
            this.options = val;
        },
        mValue(val) {
            this.value = val;
        },
        optionNum(val) {
            this.getDictionary(val);
        },
        disabledOptions(val) {
            this.options = this.filterDisabledOptions(this.options);
        }
    },
    methods: {
        filterDisabledOptions(options) {
            options = options.map(item => {
                item.disabled = this.disabledOptions.includes(item.value);
                return item;
            });
            return options;
        },
        getDictionary(optionNum = null) {
            const params = optionNum || this.optionNum;
            if (params) {
                dictWithUrl(params, this.url).then(res => {
                    if (res.code === '0') {
                        const arr = [];
                        for (const key in res.data[params]) {
                            if (res.data[params].hasOwnProperty(key)) {
                                arr.push({
                                    value: key,
                                    label: res.data[params][key]
                                });
                            }
                        }
                        this.options = this.filterDisabledOptions(arr);
                    }
                });
            } else {
                this.options = this.filterDisabledOptions(this.optionArr);
            }
        },
        sendSelectValue() {
            const data = {};
            data[this.prop] = this.value;
            let label = '';
            this.options.map(item => {
                if (item.value === this.value) {
                    label = item.label;
                }
            });
            this.$emit('getSelectValue', data, label);
            setTimeout(() => {
                this.$emit('change');
            }, 50);
        },
        clear(value) {
            this.$emit('clear', this.value);
        }
    },
    created() {
        this.getDictionary();
        this.value = this.mValue;
    }
};
</script>

<style lang="less">
    #myLotsSelect{
        width:100%;
        .el-select{
            width:100%;
        }
    }
</style>
